import * as React from 'react';

import * as classNames from 'classnames';
import DocumentMeta from 'react-document-meta';
import * as ReactGA from 'react-ga';
import withStyles, { StyledComponentProps } from 'react-jss'
import { RouteComponentProps, withRouter } from 'react-router';
import fonts from 'src/constants/fonts';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
import { InjectedApiProps, withApi } from '../_context/Api';
import Home from './Home';
import SecondaryPage from './SecondaryPage';

export type PageProps = React.HTMLAttributes<HTMLElement> & {
    loaded: boolean;
};

const styles = {
    container: {

    },
    cookiesContainer: {
        // position: 'fixed',
        // width: '100%',
        // maxWidth: 820,
        // left: '50%',
        // transform: 'translateX(-50%)',
        // ...stylesheet.PostionGutter(1, directions.bottom),
        // zIndex: 999999,
        // background: 'rgb(234,234,230)',
        // pointerEvents: 'initial',
        // boxSizing: 'border-box',

        // display: 'flex',
        // flexWrap: 'wrap',

        // '& p a': {
        //     display: 'inline-block',
        //     borderBottom: '1px solid black',
        //     ...stylesheet.Link(false, 'center'),

        //     '&:hover': {
        //         borderColor: 'transparent'
        //     },
        // },

        // [responsive.Mobile]: {
        //     bottom: 0,
        //     flexDirection: 'column',
        //     padding: spacing.Gutter.Mobile * 2 
        // },
        // [responsive.AfterMobile]: {
        //     bottom: spacing.Gutter.Desktop,
        //     padding: spacing.Gutter.Desktop
        // }
        position: 'fixed',
        width: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        ...stylesheet.PostionGutter(1, directions.bottom),
        transition: 'opacity 0.7s ease-out',
        pointerEvents: 'initial',
        zIndex: 999999,

        '& p a': {
            display: 'inline-block',
            borderBottom: '1px solid black',
            ...stylesheet.Link(false, 'center'),

            '&:hover': {
                borderColor: 'transparent'
            },
        },

        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Mobile,
            paddingRight: spacing.Gutter.Mobile,
        },
    },
    cookiesContainerInner: {
        background: 'rgb(234,234,230)',
        transition: 'opacity 0.3s ease-out',
        margin: '0 auto',
        maxWidth: 820,

        display: 'flex',
        flexWrap: 'wrap',

        [responsive.Mobile]: {
            maxWidth: '90%',
            bottom: 0,
            flexDirection: 'column',
            padding: spacing.Gutter.Mobile 
        },
        // [responsive.AfterMobile]: {
        //     maxWidth: 820,
        // },
        [responsive.AfterMobile]: {
            padding: spacing.Gutter.Desktop
        },
    },
    cookiesTitle: {
        width: '100%',
        textAlign: 'center',
        ...fonts.Sackers.Medium,
        textTransform: 'uppercase',
        paddingBottom: 10,
        fontSize: '.8rem'
    },
    cookiesContainerText: {
        width: '100%',
        ...stylesheet.PaddingGutter(1, directions.bottom)
    },
    cookiesBtn: {
        border: '1px solid black',
        ...stylesheet.Caption,
        transition: 'all 0.3s ease-in-out',
        padding: 15,
        cursor: 'pointer',

        '&:hover': {
            color: '#FFF',
            background: '#000',
        },
    },
    cookiesBtnAccept: {

        [responsive.Mobile]: {
            marginBottom: 10
        },

        [responsive.AfterMobile]: {
            marginLeft: 'auto',
            ...stylesheet.MarginGutter(.5, directions.right)
        }
    },
    cookiesBtnDecline: {
        [responsive.AfterMobile]: {
            marginRight: 'auto',
            ...stylesheet.MarginGutter(.5, directions.left)
        }
    }
}
type Props = PageProps &
    StyledComponentProps<keyof typeof styles> &
    RouteComponentProps<any> &
    InjectedApiProps & {};
type State = {
    page?: IPageDto;
    acceptCookies: string | null;
    askCookie: boolean;
}

class Page extends React.Component<Props, State> {
    static GaInited: boolean;
    private scrollContainer = document.scrollingElement ? document.scrollingElement : document.documentElement;

    constructor(props: Props) {
        super(props);

        this.state = {
            page: props.apiCtx.app && props.apiCtx.app.Page,
            acceptCookies: localStorage.getItem("cookies"),
            askCookie: false
        }
    }

    componentDidMount() {
        const { page, acceptCookies } = this.state;

        if (!page) {
            this._fetch();
        }

        if (!acceptCookies) {
            this.setState({ askCookie: true })
        }

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        const oldPath = prevProps.location.pathname;
        const currentPath = this.props.location.pathname;
        const { acceptCookies } = this.state;

        if (oldPath !== currentPath) {
            const { app } = this.props.apiCtx;
            const gaCode = app && app.Config && app.Config.GoogleAnalyticsCode;

            if (gaCode && acceptCookies === 'true') {
                setTimeout(() => this._sendPageView(gaCode))
            }

            const { page } = prevState;
            if (!page || !page.Pattern || !new RegExp(page.Pattern).test(currentPath)) {
                this._fetch();
            }
        }
    }

    public render() {
        const { loaded, apiCtx: { app }, classes } = this.props;
        const { page, acceptCookies } = this.state;
        if (!page) { return null; }

        return (
            <React.Fragment>
                <DocumentMeta
                    title={page.PageTitle || ''}
                    description={page.Description || ''}
                />
                {page.type === "Home" &&
                    <Home
                        {...{ homeDto: page as HomeDto, loaded }}
                    />}
                {page.type === "SecondaryPage" &&
                    <SecondaryPage
                        {...{ pageDto: page as SecondaryPageDto, loaded }}
                    />}

                {app &&
                    app.Config!.CookieText &&
                    acceptCookies === null &&
                    <div className={classes!.cookiesContainer}>
                        <div className={classes!.cookiesContainerInner}>
                            <div className={classes!.cookiesTitle}>
                                Cookies
                        </div>
                            <div
                                className={classes!.cookiesContainerText}
                                dangerouslySetInnerHTML={{ __html: app.Config.CookieText }} />
                            <a
                                // tslint:disable-next-line:jsx-no-lambda
                                onClick={() => {
                                    localStorage.setItem('cookies', 'true')
                                    this.setState({ acceptCookies: 'true' })
                                }}
                                className={classNames(classes!.cookiesBtn, classes!.cookiesBtnAccept)}
                            >
                                {Language === 'en' ? 'ACCEPT ALL COOKIES' : 'ACCEPTER TOUS LES COOKIES'}
                            </a>
                            <a
                                // tslint:disable-next-line:jsx-no-lambda
                                onClick={() => {
                                    localStorage.setItem('cookies', 'false')
                                    this.setState({ acceptCookies: 'false' })
                                }}
                                className={classNames(classes!.cookiesBtn, classes!.cookiesBtnDecline)}
                            >
                                {Language === 'en' ? 'DECLINE ALL COOKIES' : 'REFUSER TOUS LES COOKIES'}
                            </a>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
    private _sendPageView(gaCode: string) {

        if (gaCode) {
            if (!Page.GaInited) {
                Page.GaInited = true;
                ReactGA.initialize(gaCode);
            }
            ReactGA.pageview(window.location.pathname);
        }
    }

    private _fetch() {
        this.setState(() => {
            this.props.apiCtx.get(this.props.location.pathname).then(result => {
                this.setState(() => ({ page: result }));
            });
            return { page: undefined };
        });

    }
}

export default withStyles(styles)(withRouter(withApi(Page)));


// WEBPACK FOOTER //
// ./src/components/Page.tsx